import { combineReducers } from '@reduxjs/toolkit';
import { backendApi } from '../services/api';

const rootReducer = combineReducers({
  [backendApi.reducerPath]: backendApi.reducer,
});

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer;
